// Chat interno entre agentes contra o WootDash — /mensagens-internas. Substitui, pro
// que é WootDash (agente com Guid real), o antigo agentChatService.ts (n8n, id numérico
// do Chatwoot) — aquele fica como está, ainda serve BroadcastComposeModal.vue/
// useDashboardEngine.ts sem mudança (fora de escopo, telas Chatwoot-only).
import { WOOTDASH_BASE, wootdashAuthHeaders } from '@/api/wootdash'

export interface CpInternalMessage {
  id: number
  senderId: string
  receiverId: string
  body: string
  createdAt: string
  readAt: string | null
}

function authHeaders(token: string, json = false) {
  return { ...wootdashAuthHeaders(token), ...(json ? { 'Content-Type': 'application/json' } : {}) }
}

export async function listInternalMessages(token: string, otherAgentId: string): Promise<CpInternalMessage[]> {
  try {
    const res = await fetch(`${WOOTDASH_BASE}/mensagens-internas/${otherAgentId}`, { headers: authHeaders(token) })
    if (!res.ok) return []
    return await res.json()
  } catch {
    return []
  }
}

export async function sendInternalMessage(token: string, receiverId: string, body: string): Promise<CpInternalMessage | null> {
  try {
    const res = await fetch(`${WOOTDASH_BASE}/mensagens-internas`, {
      method: 'POST', headers: authHeaders(token, true), body: JSON.stringify({ receiverId, body }),
    })
    if (!res.ok) return null
    return await res.json()
  } catch {
    return null
  }
}

export async function getUnreadInternalMessageCounts(token: string): Promise<Record<string, number>> {
  try {
    const res = await fetch(`${WOOTDASH_BASE}/mensagens-internas/nao-lidas`, { headers: authHeaders(token) })
    if (!res.ok) return {}
    return await res.json()
  } catch {
    return {}
  }
}
